import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {BuilderSectionsInteractionService} from "../../../../builder-sections-interaction.service";
import {Config} from "../../../../../config/config";
import {filter} from "rxjs/operators";
import {BuilderV2Service} from "../../../../builder-v2.service";
import {DbModalService} from "../../../../../modules/modal/modal";
import {ReCaptchaV3Service} from "ngx-captcha";
import {User} from "../../../../../user/user";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {BuilderHistoryService} from "../../../../builder-history.service";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";

@Component({
    selector: 'db-outline-hero-generation',
    templateUrl: './outline-hero-generation.component.html',
    styleUrl: './outline-hero-generation.component.scss',
    standalone: false
})
export class OutlineHeroGenerationComponent implements OnInit, OnDestroy {
  @Input() user: User;
  @Input() popupMode: boolean = false;
  @Input() uniqueId: string;
  @Input() isEcommerce: boolean;
  private _destroyRef = inject(DestroyRef);

  @Output() showPrefilledSignup: EventEmitter<void> = new EventEmitter<void>();
  @Output() onGenerate: EventEmitter<void> = new EventEmitter<void>();

  public showSquare: boolean;
  public showGeneratingDiv: boolean = true;
  public generationFinished: boolean = false;
  public generatedTexts: any;
  public isMobile: boolean;
  public activeFont;
  public activeTheme;
  public textGenerated: boolean = false;
  public logoTitle: string = "Logo";
  showFinalize: boolean = false;

  constructor(
    private _builderService: BuilderV2Service,
    private _modalService: DbModalService,
    private _reCaptchaV3Service: ReCaptchaV3Service,
    private _cdRef: ChangeDetectorRef,
    public builderInteractionsService: BuilderSectionsInteractionService,
    public _googleAnalyticsService: GoogleAnalyticsService,
    private _historyService: BuilderHistoryService
  ) {
  }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 991;
    this.activeTheme = this.builderInteractionsService.activeTheme.value;
    this.activeFont = this.builderInteractionsService.activeFont.value;
    this.logoTitle = this.builderInteractionsService?.siteInfo?.value?.business_name;
    this._getHeroSection();
/*    if (!this.isMobile) {
      !this.textGenerated && this._generatePageTexts();
    }*/
    this._setFromHistory();
    setTimeout(() => {
      if (this.builderInteractionsService.generatePrefilledSiteLoading.value === true) {
        return;
      } else {
        if (this.user && !!localStorage.getItem('dbDemoCampaign') && !this.popupMode) {
          if (!this.isMobile) {
            this.onGenerate.emit();
            return;
          } else {
            return;
          }
        }
        this.showPrefilledSignup.emit();
      }
    }, this.isMobile ? 4500 : 2500);
  }

  private _setFromHistory() {
    const heroSection = this._historyService.getHeroSectionFromStorage();

    if (heroSection && !this.builderInteractionsService.heroSectionData.value) {
      this.builderInteractionsService.heroSectionData.next(heroSection);
    }
  }

  private _generatePageTexts() {
    const storageData = this._historyService.getHeroSectionRespFromStorage();
    if (storageData) {
      this._setGeneratedText(storageData);
      return;
    }
    this._reCaptchaV3Service.execute(Config.googleRecaptcha, 'signup', (token) => {
      const newData = {...this.builderInteractionsService.heroSectionData.value, captcha_response: token};

      this._builderService.getHeroSection(newData).pipe(
        filter(response => response && !!response),
        takeUntilDestroyed(this._destroyRef)
      ).subscribe((response) => {
        this._setGeneratedText(response);
      });
    });
  }


  private _setGeneratedText(response) {
    if (response && response.success) {
      this._historyService.setHeroSectionRespFromStorage(response);
      this.generationFinished = true;
      this.textGenerated = true;
      this.generatedTexts = response?.data;
      setTimeout(() => {
        this.showGeneratingDiv = false;
        this._cdRef.detectChanges();
      }, this.isMobile ? 6500 : 8500);
      this._cdRef.detectChanges();
    } else {
      this.generatedTexts = {
        cta: 'Learn More',
        title: 'Unlock Your Full Potential Online',
        website_type: 'basic',
        description: 'Get the tools and support you need to build, grow, and run a successful business',
        image: !!this.showSquare ? 'assets/images/ai/hero_square.jpg' : 'assets/images/ai/hero_landscape.jpg'
      };
    }
  }


  private _getHeroSection() {
    this.builderInteractionsService.heroSectionData
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(value => {
        if (!value) {
          return;
        }
        this._historyService.setHeroSectionFromStorage(value);
        const data = value;
        this.showSquare = data?.square;
        !this.textGenerated && this._generatePageTexts();
        // TODO refactor
        if (!this.builderInteractionsService.siteInfo.value?.business_name) {
          const storageData = localStorage.getItem('prefilledAiData');
          const existingData = JSON.parse(storageData);
          this.logoTitle = existingData?.business_name;
        }
      });
  }

  ngOnDestroy() {
    this._historyService.removeHeroSectionFromStorage();
    this._historyService.removeHeroSectionRespFromStorage();
  }
}
